import { BLOGS_DATA } from "./consts";
import { useNavigate } from "react-router-dom";
import React from "react";

const Blogs = () => {
  const navigate = useNavigate();

  return (
    <div className="px-6 py-12 bg-gray-50 mb-10">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
        {BLOGS_DATA.map((blog) => (
          <div
            key={blog.id}
            className="bg-white rounded-xl shadow-lg overflow-hidden transform hover:scale-105 transition duration-300"
          >
            <img
              src={blog.img}
              alt={blog.title}
              className="w-full h-64 object-cover"
            />
            <div className="p-6">
              <h3 className="text-gray-900 font-bold text-xl mb-3">
                {blog.title.split("®").map((part, index, arr) => (
                        <React.Fragment key={index}>
                          {part}
                          {index !== arr.length - 1 && <sup>®</sup>}
                        </React.Fragment>
                      ))}
              </h3>
              <p className="text-gray-600 text-lg mb-5">
                {blog.description}
              </p>
              <button
                className="bg-primary cursor-pointer text-white text-base font-semibold px-6 py-3 rounded-full"
                onClick={() => navigate(`/blogs/${blog.blogId}`)}
              >
                {blog.buttonText}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Blogs;
